/* eslint-disable react/forbid-prop-types */
// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// Utilities
import { populatePath, getUtmParams } from 'common/utils/helpers';

// Enumerables
import PublicStatus from 'common/enums/PublicStatus';

// Routes
import Routes from 'routes';

// Components
import CallToActionTile from 'project/components/CallToActionTile';

const buttonLabel = (publicStatus, t) => {
  if (publicStatus === PublicStatus.OPEN) {
    return t('project.participate_now');
  }

  if (publicStatus === PublicStatus.CLOSED) {
    return t('project.view_idea_board');
  }

  return null;
};

const IdeaBoardTile = ({ ideaBoard, match, t }) => {
  const { id, publicStatus, title, shortDescription, heroImage, startTime, endTime } = ideaBoard;

  const ideaBoardUrl = populatePath(Routes.IDEA_BOARD, {
    ...match.params,
    ideaBoardId: id,
  });
  const utmQueryString = getUtmParams();
  const ideaBoardUrlWithUtm = `${ideaBoardUrl}${utmQueryString}`;

  return (
    <CallToActionTile
      publicStatus={publicStatus}
      title={title}
      id={id}
      description={shortDescription}
      heroImage={heroImage}
      url={ideaBoardUrlWithUtm}
      startTime={startTime}
      endTime={endTime}
      buttonLabel={buttonLabel(publicStatus, t)}
    />
  );
};

IdeaBoardTile.propTypes = {
  ideaBoard: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  t: PropTypes.func.isRequired,
};

export default withRouter(withTranslation()(IdeaBoardTile));
